import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addFirstBeneficiary: 'Create a beneficiary',
    noBeneficiaries: 'No registered beneficiaries',
    sections: {
      others: 'Accounts added',
      self: 'My accounts',
    },
    seeMore: 'See More',
    unknownError: 'Oops! There was an unknown error',
  },
  fr: {
    addFirstBeneficiary: 'Créer un bénéficiaire',
    noBeneficiaries: 'Aucun bénéficiaire enregistré',
    sections: {
      others: 'Comptes Ajoutés',
      self: 'Mes comptes',
    },
    seeMore: 'Voir plus',
    unknownError: 'Oups! Une erreur inconnue est survenue',
  },
} as const);

export default locales;
